import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';

const ModalActionDelete = ({
  show,
  handleClose,
  action,
  title,
  bodyText,
  buttonText,
  branchName,
  loading
}) => {
  // * States
  const [value, setValue] = useState('');

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{`${bodyText} "${branchName}".`}</p>
        <p> Para continuar, escriba el nombre completo de la sucursal</p>
        <Form.Control
          type="text"
          size="md"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={branchName}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <div className="d-flex justify-content-end">
          <Button
            variant="danger"
            onClick={!loading && branchName === value ? action : () => {}}
            disabled={loading || branchName !== value}
            className="d-flex justify-content-center align-items-center"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              buttonText
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ModalActionDelete.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  action: PropTypes.func,
  title: PropTypes.string,
  bodyText: PropTypes.string,
  buttonText: PropTypes.string,
  branchName: PropTypes.string,
  loading: PropTypes.bool
};

export default ModalActionDelete;
